import { IconButton, IconButtonProps, Tooltip, styled } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import { CollectionIcon } from '../../navbar/components/icons/CollectionIcon';

type ButtonLinkCollectionViewerProps = {
  collectionId: string;
  iconButtonSx?: IconButtonProps['sx'];
};

export const CollectionDetailsNavButton = ({
  collectionId,
  iconButtonSx,
}: ButtonLinkCollectionViewerProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Tooltip title={t('Open in Collection Viewer')} placement='top' arrow>
      <StyledIconButton
        size='small'
        onClick={() => navigate(`/collections/${collectionId}`)}
        sx={iconButtonSx}
      >
        <CollectionIcon />
      </StyledIconButton>
    </Tooltip>
  );
};

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.vars.palette.text.secondary,
}));
